import dayjs from "dayjs";

export const validateDate = (dateStr: string) => {
  if (!dateStr) {
    return "Please enter a date.";
  }

  const date = dayjs(dateStr, "MM/DD/YYYY", true);
  const today = dayjs().endOf("day");

  if (!date.isValid()) {
    return "Invalid date. Please use MM/DD/YYYY format.";
  }

  if (date.isAfter(today)) {
    return "Date cannot be in the future.";
  }

  return "";
};
